export var TRANSACTIONS_PATH;
(function (TRANSACTIONS_PATH) {
    TRANSACTIONS_PATH["MANUAL_COMPLETE"] = "/fs/transactions/manualcomplete";
})(TRANSACTIONS_PATH || (TRANSACTIONS_PATH = {}));
